import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrencyDialogComponent } from '../../dialog/currencies/currency-dialog.component';

import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { IInvoiceReb } from '../../manage-invoice-reb/manage-invoice-reb.interfaces';

@Component({
  selector: 'dialog-factures-reb',
  templateUrl: 'dialog.component.factures-reb.html',
  styleUrls: ['dialog.component.factures-reb.css'],
  providers: [ProjectsService]
})

export class DialogFacturesReb {
  //public possibleMonedes: Array<string>;
  public possibleMonedes: { codi: string; text: string; }[];

  public possibleConceptes: Array<string>;
  public invoice: IInvoiceReb = {'id': 0, 'projecte_codi': '', 'fita': '', 'objecte_lliurament': '',
    'facturacio_prevista_percent': 0, 'facturacio_prevista_eur': 0, 'numero_factura': '', 'observacions': '',
    'data_factura': '', 'data_pagament': '', 'data_factura_prevista': '', 'data_pagament_prevista': '',
    'impostos':0, 'facturacio_loc': 0,  'moneda_facturacio': '', 'canvi_moneda': 0, 'subcontractacio': 0,
    'concepte': '', 'activa': true, 'clau': ''};
    public editInvoiceData = Object.assign(
      this.invoice,
      {},
      {}
    );

  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProjectsService, private dialog: MatDialog, public dialogRef: MatDialogRef<DialogFacturesReb>, @Inject(MAT_DIALOG_DATA) public data: any){
    this.editInvoiceData =  data;
    //this.dataService.getMonedes().subscribe(monedes => this.possibleMonedes = monedes, err => console.log(err));
    this.dataService.getMonedes().subscribe(monedes => {
      this.possibleMonedes = monedes.map(nomCatala => ({
        codi: nomCatala["value"], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('monedesRaw', nomCatala["value"]) // ← només es mostra traduït
      }));
    });

    this.dataService.getConceptes().subscribe(conceptes => this.possibleConceptes = conceptes, err => console.log(err));
    if(!this.editInvoiceData.canvi_moneda)this.editInvoiceData.canvi_moneda = 1;
    if(!this.editInvoiceData.moneda_facturacio)this.editInvoiceData.moneda_facturacio = 'Euro';
  }

  public openCurrencyDialog(): void {
    this.dialog.open(CurrencyDialogComponent, {
      panelClass: 'currency-dialog-panel',
      autoFocus: false
    });
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    if(!(this.editInvoiceData.data_factura_prevista == null || this.editInvoiceData.data_factura_prevista == '') && isNaN(Date.parse(this.editInvoiceData.data_factura_prevista))){alert("Data factura prevista. Invalida");return;}
    if(!(this.editInvoiceData.data_pagament_prevista == null || this.editInvoiceData.data_pagament_prevista == '') && isNaN(Date.parse(this.editInvoiceData.data_pagament_prevista))){alert("Data pagament prevista. Invalida");return;}
    if(!(this.editInvoiceData.data_factura == null || this.editInvoiceData.data_factura == '') && isNaN(Date.parse(this.editInvoiceData.data_factura))){alert("Data factura. Invalida");return;}
    if(!(this.editInvoiceData.data_pagament == null || this.editInvoiceData.data_pagament == '') && isNaN(Date.parse(this.editInvoiceData.data_pagament))){alert("Data pagament. Invalida");return;}

    this.editInvoiceData.facturacio_prevista_eur = (!this.editInvoiceData.facturacio_loc)?0:this.editInvoiceData.facturacio_loc*this.editInvoiceData.canvi_moneda;
    this.dialogRef.close(this.editInvoiceData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit(){
  }
}